import React, { useState, useRef } from "react";
import { Button, Checkbox, MapDemoContext } from "..";
import { getDemoById } from "../../list";
import axios from "axios";
import polyline from "google-polyline";
import URL from "./../../URL";
import "./sidebar.css";

function Sidebar({ className, items, options }) {
  const des_form = useRef(null);

  let _destinations;
  let _updateDestinations;
  let _drawRoutes;
  let _markers;
  let _updateMarkers;
  let _apiKey;
  let _updateName;
  let _updateAddress;
  let _updateLocation;
  let _updateAddressId;
  let _fleet;
  let _updateCenterCoordinate;
  let _setSelectedSourceIndex;
  let _setMessage;
  let _setTime;

  let routeColor = [
    ['#5B5D2C', '#6D7100', '#ABB107', '#D3D66B', '#BFC189'],
    ['#4A235A', '#7D3C98', '#A569BD', '#BB8FCE', '#BB8FCE'],
    ['#1B4F72', '#2874A6', '#3498DB', '#45B4FE', '#AED6F1'],
    ['#117864', '#48C9B0', '#1ABC9C', '#73C6B6', '#A3E4D7'],
    ['#6E2C00', '#935116', '#7E5109', '#CA6F1E', '#B9770E']
  ]

  const [demoName, setDemoName] = useState("");
  const [capacityValue, setCapacityValue] = useState([]);
  const [twFromValue, setTwFromValue] = useState([]);
  const [twToValue, setTwToValue] = useState([]);
  const [capacity, setCapacity] = useState(false);
  const [timeWindow, setTimeWindow] = useState(false);
  const [showRouteItemsInfo, setShowRouteItemsInfo] = useState(false);
  const [vehicle, setVehicle] = useState([]);
  const [vrpIsSolved, setVrpIsSolved] = useState(false);
  const [tspIsSolved, setTspIsSolved] = useState(false);

  function setContexts(
    __destinations,
    __updateDestinations,
    __drawRoutes,
    __markers,
    __updateMarkers,
    __apiKey,
    __updateName,
    __updateAddress,
    __updateLocation,
    __updateAddressId,
    __demo,
    __fleet,
    __updateCenterCoordinate,
    __setSelectedSourceIndex,
    __setMessage,
    __setTime
  ) {
    _destinations = __destinations;
    _updateDestinations = __updateDestinations;
    _drawRoutes = __drawRoutes;
    _markers = __markers;
    _updateMarkers = __updateMarkers;
    _apiKey = __apiKey;
    _updateName = __updateName;
    _updateAddress = __updateAddress;
    _updateLocation = __updateLocation;
    _updateAddressId = __updateAddressId;
    _fleet = __fleet;
    _updateCenterCoordinate = __updateCenterCoordinate;
    _setSelectedSourceIndex = __setSelectedSourceIndex;
    _setMessage = __setMessage;
    _setTime = __setTime;

    setDemoName(__demo.toLowerCase());
    if (__demo === "Vrp") {
      setShowRouteItemsInfo(true);
    }
  }

  let classes = ["map-sidebar", className, `${demoName}-sidebar`];
  if (vrpIsSolved || tspIsSolved) classes.push("solved");

  const displayLocadingAnimation = (toShow = true) => {
    // problem is tsp or vrp
    let demoContainerElement = document.querySelector(".demo-container");
    if (toShow) demoContainerElement.classList.add("loading");
    if (!toShow) demoContainerElement.classList.remove("loading");
  };

  const solveTSP = (e) => {
    e.preventDefault();

    // check if there is already an answer and start again
    if (tspIsSolved) {
      _updateDestinations([]);
      setTspIsSolved(false);
      _updateMarkers([]);
      _drawRoutes([]);
      _setSelectedSourceIndex(-1);
      return;
    }

    displayLocadingAnimation();
    // check if roundtrip checkbox is checked
    let destination;
    let __destinations = [..._destinations];
    let roundtrip = document.querySelector(
      '.map-sidebar .options input[name="roundtrip"]'
    ).checked;

    if (roundtrip) destination = "any";
    else destination = "last";

    // check if a source is checked and if so make it first destination
    // and set source to 'first' otherwise 'any'
    let source = "any";

    let sources = [
      ...document.querySelectorAll(
        '.map-sidebar .item-option-chackbox input[name="origin"]'
      ),
    ];

    let selectedSourceIndex = sources.map((s) => s.checked).findIndex((c) => c);

    if (selectedSourceIndex > -1) {
      source = "first";
      __destinations = [
        ...__destinations.splice(selectedSourceIndex, 1),
        ...__destinations,
      ];
    } else if (!roundtrip) {
      source = "first";

      document.querySelector(
        '.map-sidebar .item-option-chackbox input[name="origin"]'
      ).checked = true;
    }

    // format destinations lat/lng to lat,lng;lat,lng...
    let locations = __destinations
      .map((d) => [d.location.lng, d.location.lat].join(","))
      .join(";");

    let routeOptions = {
      roundtrip,
      source,
      destination,
      steps: true,
      overview: "full",
    };

    let queries = Object.entries(routeOptions)
      .map((query) => query.join("="))
      .join("&");

    // let base_url = process.env.REACT_APP_ENDPOINT_TSP;
    // if (!base_url.endsWith('/')) base_url = base_url + '/';
    // let url = new URL(`${locations}?${queries}`, base_url).href;

    axios({
      method: "GET",
      url: URL.tsp + `/${locations}?${queries}`,
      headers: {
        "x-api-key": _apiKey,
      },
      data: queries,
    })
      .then(function (res) {
        let temDes = [];
        __destinations.forEach((element) => {
          temDes.push(element);
        });
        let geojsonpoint = [];

        let legPoints = [];
        res.data.trips[0].legs.forEach((legs) => {
          let decodeResult;
          let stepsPoints = [];
          legs.steps.forEach((step) => {
            decodeResult = polyline
              .decode(step.geometry)
              .map((items) => items.reverse());

            stepsPoints.push(...decodeResult.slice(0, -1));
            // legPoints.push(decodeResult.slice(0,-1))
            // temp += step.geometry
          });

          legPoints.push({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {
                  title: legs.summary,
                  stroke: "#5874d8",
                },
                geometry: {
                  type: "LineString",
                  coordinates: [...stepsPoints],
                },
              },
            ],
          });
          // geojsonpoint.push()
        });

        geojsonpoint = legPoints;
        // let decodeResult = polyline.decode(res.data.trips[0].geometry);

        items = [
          ...document.querySelectorAll(".items-container .item-wrapper"),
        ].forEach((item) => (item.style.order = 0));

        res.data.waypoints.forEach((element) => {
          let item = temDes.findIndex(
            (item) =>
              (item.location.lat.toFixed(2) ===
                element.location[1].toFixed(2)) &
              (item.location.lng.toFixed(2) === element.location[0].toFixed(2))
          );
          temDes[item].waypoint_index = element.waypoint_index;
        });

        _updateDestinations(temDes.sort(compare));

        function compare(a, b) {
          // Use toUpperCase() to ignore character casing
          const bandA = a.waypoint_index;
          const bandB = b.waypoint_index;

          let comparison = 0;
          if (bandA > bandB) {
            comparison = 1;
          } else if (bandA < bandB) {
            comparison = -1;
          }
          return comparison;
        }

        let newMarkers = [];
        res.data.waypoints.sort(compare).forEach((element) => {
          newMarkers.push(element.location);
        });

        _updateMarkers(newMarkers);
        _drawRoutes(geojsonpoint);
        _setSelectedSourceIndex(0);
        setTimeout(() => {
          displayLocadingAnimation(false);
          setTspIsSolved(true);
        }, 3000);
      })
      .catch(function (err) {
        console.error(err);
        setTimeout(() => {
          displayLocadingAnimation(false);
        }, 3000);
      });
  };

  const solveVRP = (e) => {
    e.preventDefault();

    if (vrpIsSolved) {
      setVrpIsSolved(false);
      _updateDestinations([]);
      _updateMarkers([]);
      _drawRoutes([]);
      return;
    }

    displayLocadingAnimation();
    // check if roundtrip checkbox is checked
    // let destination;
    let roundtrip = document.querySelector(
      '.map-sidebar .options input[name="roundtrip"]'
    ).checked;

    // if (roundtrip) destination = "any";
    // else destination = "last";

    // check if a source is checked and if so make it first destination
    // and set source to 'first' otherwise 'any'
    // let source = "any";

    // let sources = [
    //   ...document.querySelectorAll(
    //     '.map-sidebar .item-option-chackbox input[name="origin"]'
    //   ),
    // ];

    // let selectedSourceIndex = sources.map((s) => s.checked).findIndex((c) => c);

    // if (selectedSourceIndex > -1) {
    //   // source = "first";
    //   _destinations = [
    //     ..._destinations.splice(selectedSourceIndex, 1),
    //     ..._destinations,
    //   ];
    // } else if (!roundtrip) {
    //   // source = "first";

    //   document.querySelector(
    //     '.map-sidebar .item-option-chackbox input[name="origin"]'
    //   ).checked = true;
    // }

    // format destinations lat/lng to lat,lng;lat,lng...

    // We don't know vrp has query params or not!!!
    // let locations = _destinations
    //   .map(d => [d.location.lng, d.location.lat].join(","))
    //   .join(";");

    // let routeOptions = {
    //   roundtrip,
    //   source,
    //   destination,
    //   steps: true,
    //   overview: "full"
    // };

    // let queries = Object.entries(routeOptions)
    //   .map(query => query.join("="))
    //   .join("&");

    let services = [];
    _destinations.forEach((d, idx) => {
      if (capacity && timeWindow) {
        services.push({
          id: idx.toString(),
          name: d.name,
          duration: d.time,
          address: {
            location_id: d.id.toString(),
            type: "Point",
            coordinates: [d.location.lng, d.location.lat],
          },
          size: [capacityValue[idx]],
          time_windows: [
            {
              earliest: twFromValue[idx],
              latest: twToValue[idx],
            },
          ],
        });
        return;
      } else if (capacity) {
        services.push({
          id: idx.toString(),
          name: d.name,
          duration: d.time,
          address: {
            location_id: d.id.toString(),
            type: "Point",
            coordinates: [d.location.lng, d.location.lat],
          },
          size: [capacityValue[idx]],
        });
        return;
      } else {
        services.push({
          id: idx.toString(),
          name: d.name,
          duration: d.time,
          address: {
            location_id: d.id.toString(),
            type: "Point",
            coordinates: [d.location.lng, d.location.lat],
          },
        });
      }
    });

    const demoName = window.location.pathname.split("/")[2];
    const demo = getDemoById(demoName);
    const demoData = demo.data;

    const getVehicleNameById = (id) => {
      return Object.entries(demoData.vehicles)[id][0];
    };

    // const getVehicleIDByName = (name) => {
    //   return Object.entries(demoData.vehicles).findIndex(item => item[0] === name)
    // };

    let vehicle_types = Object.entries(demoData.vehicles).map((v) => ({
      type_id: v[0],
      capacity: v[1].capacity,
    }));

    // Just because we're so awesome! //wait... what??
    // :)))) just exploring different (not simple) ways to do simplest tasks.

    // function* range(end, start = 0) {
    //   for (let i = start; i < end; i++) {
    //       yield i;
    //   }
    // }

    if (!_fleet.length)
      _fleet = [
        {
          typeID: 0,
          name: "تست#۱",
          count: 2,
        },
        {
          typeID: 2,
          name: "تست#۲",
          count: 2,
        },
      ];

    let __fleet = _fleet.flatMap((fleetItem) =>
      Array(parseInt(fleetItem.count))
        .fill()
        .map((item, i) => ({
          vehicle_id: `${fleetItem.name}-${i}`,
          start_address: {
            location_id: "shiveh", // previously: v1_gera
            type: "point",
            coordinates: [51.422681, 35.732544],
          },
          type_id: getVehicleNameById(fleetItem.typeID),
          return_to_depot: roundtrip,
        }))
    );

    let data =
      capacity && timeWindow
        ? {
            vehicles: __fleet,
            vehicle_types: vehicle_types,
            services: services,
          }
        : capacity
        ? {
            vehicles: __fleet,
            vehicle_types: vehicle_types,
            services: services,
          }
        : {
            vehicles: __fleet,
            vehicle_types: vehicle_types,
            services: services,
          };

    // let base_url = process.env.REACT_APP_ENDPOINT_CVRPTW;
    // if (!base_url.endsWith('/')) base_url = base_url + '/';
    // let url = new URL(`${(capacity ? 'c' : '')}vrp${(capacity && timeWindow ? 'tw' : '')}`, base_url).href;

    axios({
      method: "POST",
      url:
        URL.vrp +
        `/${capacity ? "c" : ""}vrp${capacity && timeWindow ? "tw" : ""}`,
      headers: {
        "x-api-key": _apiKey,
      },
      data: data,
    })
      .then(function (res) {
        // let decodeResult = polyline.decode(res.data.trips[0].geometry);
        // let reverseLatLon = decodeResult.map(items => items.reverse());
        // let geojsonpoint = [
        //   {
        //     type: "FeatureCollection",
        //     features: [
        //       {
        //         type: "Feature",
        //         properties: {},
        //         geometry: {
        //           type: "LineString",
        //           coordinates: reverseLatLon
        //         }
        //       }
        //     ]
        //   }
        // ];

        // remove options-wrapper
        // document.querySelector(".options-wrapper").style.display = "none";

        let geojsonpoint = [];

        let legPoints = [];
        let newMarkers = [];
        let vehicles = [];

        res.data.value[0].solution.forEach((solution, idx) => {
          let destinationVehicle = [];
          if (solution.length < 1) return;
          solution.routes.legs.forEach((legs) => {
            let decodeResult;
            let stepsPoints = [];
            legs.steps.forEach((step) => {
              decodeResult = polyline
                .decode(step.geometry)
                .map((items) => items.reverse());

              stepsPoints.push(...decodeResult.slice(0, -1));
              // legPoints.push(decodeResult.slice(0,-1))
              // temp += step.geometry
            });

            let tempColor = () => {
              switch (solution.vehicle_type) {
                case "موتورسیکلت":
                  return routeColor[0][`${idx%5}`];
                case "وانت سبک":
                  return routeColor[1][`${idx%5}`];
                case "وانت نیسان":
                  return routeColor[2][`${idx%5}`];
                case "کامیونت":
                  return routeColor[3][`${idx%5}`];
                case "کامیون":
                  return routeColor[4][`${idx%5}`];
                default:
                  break;
              }
            };

            legPoints.push({
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  properties: {
                    title: solution.vehicle_id,
                    stroke: tempColor(),
                  },
                  geometry: {
                    type: "LineString",
                    coordinates: [...stepsPoints],
                  },
                },
              ],
            });
            // geojsonpoint.push()
          });
          geojsonpoint[idx] = legPoints;

          solution.activities.forEach((activities) => {
            newMarkers.push(activities.location.coordinates);
            destinationVehicle.push({
              name: activities.name,
              size: activities.size,
              arr_time: activities.arr_time,
              end_time: activities.end_time,
            });
          });
          vehicles.push({
            name: solution.vehicle_id,
            arr_time: solution.activities[0].arr_time,
            end_time:
              solution.activities[solution.activities.length - 1].end_time,
            destination: destinationVehicle,
          });
        });

        let destinationsToUpdate = vehicles.flatMap(v => v.destination.sort((a, b) => parseInt(a.id) - parseInt(b.id)))

        if (geojsonpoint.length) {
          if(res.data.value[0].no_unassigned > 0) {
            _setMessage({
              text: (<><p> {res.data.value[0].no_unassigned} {" "}بار تعیین شده به دلیل عدم تطابق با ناوگان تحویل داده نشد!</p><p className="unassigned-detail" onClick={() => showUnassigned(res.data.value[0].unassigned.services)}>مشاهده جزئیات</p></>),
              type: 'unassigned'
            });
          }
          setVehicle(vehicles);
          _updateMarkers(newMarkers);
          _drawRoutes(geojsonpoint[0]);
          _updateDestinations(destinationsToUpdate);
          setVrpIsSolved(true);
        }
        else {
          if(res.data.value[0].no_unassigned > 0) {
            _setMessage({
            text: (<><p> {res.data.value[0].no_unassigned} {" "} بار تعیین شده به دلیل عدم تطابق با ناوگان تحویل داده نشد!</p><p className="unassigned-detail" onClick={() => showUnassigned(res.data.value[0].unassigned.services)}>مشاهده جزئیات</p></>),
              type: 'unassigned'
            });
          } else {
            _setMessage({
              text: 'برای مسئله جوابی دریافت نشد.',
              type: 'not-found'
            });
          }
        }

        setTimeout(() => {
          displayLocadingAnimation(false);
        }, 3000);
      })
      .catch(function (err) {
        console.error(err);
        setTimeout(() => {
          displayLocadingAnimation(false);
          _setMessage({
            text: 'دریافت نتیجه مسیریابی با مشکل مواجه شد. دوباره تلاش کنید.',
            type: 'not-found'
          });
        }, 3000);
      });
  };

  const InvalidMsg = (textbox, requiredMessage, wrongMessage, setMessage) => {
    textbox.focus();
    textbox.parentNode.classList.add("error")
    if (textbox.value === "") {
      textbox.setCustomValidity(requiredMessage);
      setMessage({
        text: requiredMessage,
        type: 'validation'
      })
    } else if (
      textbox.validity.typeMismatch ||
      textbox.validity.patternMismatch
    ) {
      textbox.setCustomValidity(wrongMessage);
      setMessage({
        text: wrongMessage,
        type: 'validation'
      })
    } else {
      textbox.setCustomValidity("");
      setMessage({
        text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
        type: 'default'
      })
      textbox.parentNode.classList.remove("error")
    }

    return true;
  };

  const showUnassigned = (unassigned) => {
    let unassigned_name = []
    unassigned.forEach((element, idx) => {
    unassigned_name.push(<p key={Math.random()}>{idx + 1}.{_destinations[element].name}</p>)
    })
    _setMessage({
      text: (<><p className="unassigned-title">بارهای تحویل داده نشده</p><p>نام مقصد:</p><div className="unassigned-wrapper">{unassigned_name}</div><p className="unassigned-return" onClick={() => _setMessage({
        text: (<><p> {unassigned.length}بار تعیین شده به دلیل عدم تطابق با ناوگان تحویل داده نشد!</p><p className="unassigned-detail" onClick={() => showUnassigned(unassigned)}>مشاهده جزئیات</p></>),
        type: 'unassigned'
      })}>بازگشت</p></>),
      type: ''
    });
  }

  return (
    <MapDemoContext.Consumer>
      {({
        destinations,
        updateDestinations,
        drawRoutes,
        markers,
        updateMarkers,
        apiKey,
        updateName,
        updateAddress,
        updateLocation,
        updateAddressId,
        demo,
        fleet,
        updateCenterCoordinate,
        setSelectedSourceIndex,
        setMessage,
        setTime
      }) => {
        setContexts(
          destinations,
          updateDestinations,
          drawRoutes,
          markers,
          updateMarkers,
          apiKey,
          updateName,
          updateAddress,
          updateLocation,
          updateAddressId,
          demo,
          fleet,
          updateCenterCoordinate,
          setSelectedSourceIndex,
          setMessage,
          setTime
        );
        let buttonDisabled = _destinations.length < 3;
        let itemsHeader = undefined;

        if (_destinations.length) {
          itemsHeader = (
            <div className="items-header">
              <div
                className="item-header-option-chackbox"
                style={{ display: `${demoName === "tsp" ? "" : "none"}` }}
              >
                مبدا
              </div>
              <div className="item-header-option-name">نام مقصد</div>
              {demoName === "vrp" ? (
                <div className="item-header-option-time">زمان توقف</div>
              ) : (
                ""
              )}
              <div className="item-header-option-edit">ویرایش</div>
            </div>
          );
        }
        if (vrpIsSolved) {
          itemsHeader = (
            <div className="items-header vrp-solution">
              <div className="item-header-option-name">
                ناوگان / پنجره زمانی کلی
              </div>
              {/* <div className="item-header-option-name">پنجره زمانی کلی</div> */}
            </div>
          );
        }

        // Chnage order of item whose source option is checked
        // so that it is first item in the list
        function sourceChanged(e) {
          let target = e.target;
          items = [
            ...document.querySelectorAll(".items-container .item-wrapper"),
          ].forEach((item) => (item.style.order = 0));
          if (target.checked) target.closest(".item-wrapper").style.order = -1;

          let _selectedxIndex = [
            ...document.querySelectorAll(".items-container .item-wrapper"),
          ].findIndex((item) => item.style.order === "-1");

          setSelectedSourceIndex(_selectedxIndex);
        }

        function roundtripChanged(e) {
          let sources = [
            ...document.querySelectorAll(
              '.map-sidebar .item-option-chackbox input[name="origin"]'
            ),
          ];
          let selectedSourceIndex = sources
            .map((s) => s.checked)
            .findIndex((c) => c);
          let firstItem = document.querySelector(
            '.map-sidebar .item-option-chackbox input[name="origin"]'
          );
          if (firstItem && selectedSourceIndex === -1) firstItem.checked = true;
        }

        function handleEdit(e, d) {
          const target = e.target;
          const moreBtn = target.closest('.item-option-more');
          moreBtn.classList.add('open');

          if(target.classList.contains('edit')) {
            if (document.querySelector('.destination-name input').value.length) {
              // ToDO: send message to submit button first
              _setMessage({
                text: 'ابتدا نشانی قبلی را تایید نمایید.',
                type: 'validation'
              });
              moreBtn.classList.remove('open');
              return;
            }

            _updateCenterCoordinate(d.location);
            _updateName(d.name);
            _updateAddress(d.address);
            _updateLocation(d.location);
            _updateAddressId(d.id);
            if ('time' in d) _setTime(d.time);
            moreBtn.classList.remove('open');
          }
          if(target.classList.contains('remove')) {
            // Remove Item
            moreBtn.classList.remove('open');
            let indexToRemove = _destinations.findIndex(destination => destination.id === d.id);
            _updateDestinations(_destinations.filter(destination => destination.id !== d.id));
            _updateMarkers(_markers.filter((_,i) => i !== indexToRemove));
            document.querySelector('.main-bar').dataset.id -= 1; 
          }
        }

        let __destinations = _destinations.map((d, d_idx) => {
          let itemInfo = [];

          if (showRouteItemsInfo === true) {
            itemInfo =
              capacity || timeWindow ? (
                <>
                  <div className="item-info-header">
                    {capacity ? (
                      <div className="item-info-header-capacity">
                        حجم بار تحویلی
                      </div>
                    ) : (
                      ""
                    )}

                    {timeWindow ? (
                      <div className="item-info-timewindow">پنجره زمانی</div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="item-info" data-id={d.id}>
                    {capacity ? (
                      <div className="item-info-capacity">
                        <input
                          required
                          pattern="[0-9۰-۹]+"
                          onInvalid={(e) => {
                            InvalidMsg(
                              e.target,
                              "لطفا حجم بار تحویلی را وارد نمایید",
                              "از اعداد صحیح مثبت استفاده نمایید.",
                              setMessage
                            );
                          }}
                          onChange={(e) => {
                            let tempCapacity = capacityValue;
                            tempCapacity[d.id] = window.toEnglishDigits(e.target.value);
                            setCapacityValue(tempCapacity);
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {timeWindow ? (
                      <>
                        <div className="item-info-time from">
                          <input
                            required
                            placeholder="00:00"
                            pattern="\d{1,2}:\d{1,2}:\d{1,2}"
                            onInvalid={(e) => {
                              InvalidMsg(
                                e.target,
                                "لطفا ابتدای پنجره زمانی را وارد نمایید",
                                "لطفا از فرمت ۰۰:۰۰:۰۰ استفاده نمایید",
                                setMessage
                              );
                            }}
                            onChange={(e) => {
                              let tempTwFrom = twFromValue;
                              tempTwFrom[d.id] = window.toEnglishDigits(e.target.value);
                              setTwFromValue(tempTwFrom);
                            }}
                          />
                        </div>
                        <div className="item-info-time to">
                          <input
                            required
                            placeholder="00:00"
                            pattern="\d{1,2}:\d{1,2}:\d{1,2}"
                            onInvalid={(e) => {
                              InvalidMsg(
                                e.target,
                                "لطفا انتهای پنجره زمانی را وارد نمایید",
                                "لطفا از فرمت ۰۰:۰۰:۰۰ استفاده نمایید",
                                setMessage
                              );
                            }}
                            onChange={(e) => {
                              let tempTwTo = twToValue;
                              tempTwTo[d.id] = window.toEnglishDigits(e.target.value);
                              setTwToValue(tempTwTo);
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                []
              );
          }

          return (
            <div className="item-wrapper" data-id={d.id} key={d_idx}>
              <div className="item">
                {demoName === "tsp" && !tspIsSolved ? (
                  <div className="item-option-chackbox">
                    <Checkbox linked name="origin" onChange={sourceChanged} />
                  </div>
                ) : null}
                {/** add checked={idx === 0} to check first item */}
                <div className="item-option-name">
                  <span>{d.name}</span>
                </div>
                {demoName === "vrp" ? (
                  <div className="item-option-time">{d.time}</div>
                ) : (
                  ""
                )}
                <div
                  className="item-option-more"
                  onClick={(e) => handleEdit(e, d)}
                >
                  <span title="ویرایش" className="edit"></span>
                  <span title="حذف" className="remove"></span>
                </div>
              </div>

              {itemInfo}
            </div>
          );
        });

        let vrpSolution = vehicle.map((v, idx) => {
          let itemInfo = [];
          let itemInfo2 = [];
          itemInfo = (
            <div className="item-info vrp-solution-info" key={idx}>
              <div className="item-option-name">
                <span>{v.name}</span>
              </div>
              <div className="item-info-time from">
                <input placeholder="00:00" defaultValue={v.arr_time} />
              </div>
              <div className="item-info-time to">
                <input placeholder="00:00" defaultValue={v.end_time} />
              </div>
            </div>
          );
          itemInfo2 = v.destination.sort((a, b) => parseInt(a.id) - parseInt(b.id)).map((vd, idx2) => {
            return (
              <div className="item-info vrp-solution-info2" key={`${idx}-${idx2}`}>
                <div className="item-option-name">
                  <span>{vd.name}</span>
                </div>
                <div className="item-option-name">
                  <span>{vd.size}</span>
                </div>
                <div className="item-info-time from">
                  <input placeholder="00:00" defaultValue={vd.arr_time} />
                </div>
                <div className="item-info-time to">
                  <input placeholder="00:00" defaultValue={vd.end_time} />
                </div>
              </div>
            );
          });
          return (
            <div className="item-wrapper" key={`i${idx}`}>
              <div className="item vrp-solution-item">{itemInfo}</div>
              <div className="item-info-header vrp-solution-info">
                <div className="item-info-header-capacity">نام مقصد</div>
                <div className="item-info-header-capacity">حجم بار تحویلی</div>
                <div className="item-info-header-capacity">پنجره زمانی</div>
              </div>
              <div className="vrp-solution-wrapper">{itemInfo2}</div>
            </div>
          );
        });

        return (
          <div className={classes.join(" ")}>
            <form ref={des_form}>
              <div className="sidebar-wrapper">
                <div className="sidebar-items">
                  {itemsHeader}
                  <div className="items-container">
                    {vrpIsSolved
                      ? vrpSolution
                      : __destinations.length
                      ? __destinations
                      : "مقاصد انتخاب شده اینجا نمایش‌داده خواهند شد."}
                  </div>
                </div>
              </div>
              <div className="options-wrapper">
                <div
                  className="options"
                  style={{
                    visibility: `${
                      vrpIsSolved === true || tspIsSolved === true
                        ? "hidden"
                        : "visible"
                    }
                  `,
                  }}
                >
                  <div className="options-item">
                    <Checkbox
                      checked
                      name="roundtrip"
                      onChange={roundtripChanged}
                    >
                      بازگشت به مبدا
                    </Checkbox>
                    {demoName === "vrp" ? (
                      <>
                        <Checkbox
                          name="capacity"
                          onChange={() =>
                            capacity ? setCapacity(false) : setCapacity(true)
                          }
                          changeable={!timeWindow}
                        >
                          حجم بار تحویلی
                        </Checkbox>
                        <Checkbox
                          name="timewindow"
                          onChange={() =>
                            timeWindow
                              ? setTimeWindow(false)
                              : setTimeWindow(true) &
                                setCapacity(!capacity ? true : true) &
                                (document.querySelector(
                                  '.map-sidebar input[name="capacity"]'
                                ).checked = true)
                          }
                        >
                          پنجره زمانی تحویل
                        </Checkbox>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="submit-wrapper">
                  <div className="submit">
                    <Button
                      disabled={buttonDisabled}
                      onClick={(e) => {
                        if (des_form.current.checkValidity()) {
                          e.preventDefault();
                          demoName === "vrp" ? solveVRP(e) : solveTSP(e);
                        } else {
                          e.preventDefault();
                          // des_form.current.reportValidity();
                        }
                      }}
                    >
                      {vrpIsSolved === true || tspIsSolved === true
                        ? "شروع مجدد"
                        : "شروع مسیردهی"}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="sidebar-bg"></div>
            </form>
          </div>
        );
      }}
    </MapDemoContext.Consumer>
  );
}

export default Sidebar;
